import { render, staticRenderFns } from "./doctorOrder.vue?vue&type=template&id=4cf668ff&scoped=true&"
import script from "./doctorOrder.vue?vue&type=script&lang=js&"
export * from "./doctorOrder.vue?vue&type=script&lang=js&"
import style0 from "./doctorOrder.vue?vue&type=style&index=0&id=4cf668ff&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf668ff",
  null
  
)

component.options.__file = "doctorOrder.vue"
export default component.exports